/************************************** product addons *******************************************/

(function (window) {
  if (window.ProductAddons) {
    return;
  }

  const items = new Set();
  const listeners = new Set();

  function notify() {
    const snapshot = [...items];

    listeners.forEach(listener => {
      listener(snapshot);
    });
  }

  window.ProductAddons = {
    getItems() {
      return [...items];
    },

    addItem(item) {
      if (!items.has(item)) {
        items.add(item);
        notify();
      }
    },

    removeItem(item) {
      if (items.has(item)) {
        items.delete(item);
        notify();
      }
    },

    clear() {
      items.clear();
      notify();
    },

    subscribe(listener) {
      listeners.add(listener);
      listener([...items]);

      return function unsubscribe() {
        listeners.delete(listener);
      };
    }
  };
})(window);

window.ProductAddons.subscribe(function (items) {
  console.log('state update', items);
});

class ProductAddonBase extends HTMLElement {
  currentVariantId;
  radioButtons;

  constructor() {
    super();

    this.radioButtons = this.querySelectorAll('input[type="radio"]');
    if (this.radioButtons.length) {
      this.radioButtons.forEach(radioButton => {
        radioButton.addEventListener('change', this.onVariantChange.bind(this));
      });
    }
  }

  onVariantChange(event) {
    const variantElements = this.querySelectorAll('[data-addon-variant-id]');
    this.currentVariantId = event.target.value;

    variantElements.forEach(variantElement => {
      variantElement.toggleAttribute('hidden', variantElement.dataset.addonVariantId !== this.currentVariantId);
    });
  }
}

class ProductAddon extends ProductAddonBase {
  checkbox;

  constructor() {
    super();
    this.checkbox = this.querySelector('input[type="checkbox"]');
    this.checkbox.addEventListener('change', this.onCheckboxChange.bind(this));
    this.currentVariantId = this.checkbox.dataset.variant;

    const variantInputs = Array.from(this.querySelectorAll('input[type="radio"]'));
    const variantIds = variantInputs.map(variantInput => variantInput.value);

    window.ProductAddons.subscribe((items) => {
      if (variantIds.length) {
        if (!this.checkbox.checked && variantIds.some(variantId => items.includes(variantId))) {
          this.updateCheckboxState(true);
        }
      } else {
        this.updateCheckboxState(items.includes(this.currentVariantId));
      }
    });
  }

  onCheckboxChange(event) {
    if (event.synthetic) {
      return;
    }

    if (event.target.checked) {
      window.ProductAddons.addItem(this.currentVariantId);
    } else {
      window.ProductAddons.removeItem(this.currentVariantId);
    }
  }

  onVariantChange(event) {
    window.ProductAddons.removeItem(this.currentVariantId);
    super.onVariantChange(event);
    if (this.checkbox.checked) {
      window.ProductAddons.addItem(this.currentVariantId);
    }
  }

  updateCheckboxState(checked) {
    this.checkbox.checked = checked;
    const event = new Event('change', { bubbles: false });

    Object.defineProperty(event, 'synthetic', {
      value: true
    });

    this.checkbox.dispatchEvent(event);
  }
}

if (!customElements.get('product-addon')) {
  customElements.define('product-addon', ProductAddon);
}

class ProductAddonModal extends ProductAddonBase {
  addButton;
  addButtonContent;
  closeButton;
  mainSwiper;
  thumbSwiper;

  constructor() {
    super();

    this.addButton = this.querySelector('button.modal-button');
    this.addButtonContent = this.addButton.querySelector('.modal-button__content');
    this.addButton.addEventListener('click', this.onButtonClick.bind(this));
    this.currentVariantId = this.addButton.dataset.variant;

    this.closeButton = this.querySelector('.product-addon-modal-close');
    this.initSwipers();

    window.ProductAddons.subscribe((items) => {
      this.updateButtonState(items.includes(this.currentVariantId));
    });
  }

  onVariantChange(event) {
    super.onVariantChange(event);
    this.updateButtonState(window.ProductAddons.getItems().includes(this.currentVariantId));

    if (this.mainSwiper && this.thumbSwiper) {
      let targetIndex = 0;
      for (let i = 0; i < this.thumbSwiper.slides.length; i++) {
        if (this.thumbSwiper.slides[i].dataset.variant === this.currentVariantId) {
          targetIndex = i;
        }
      }
      this.mainSwiper.slideTo(targetIndex);
    }
  }

  onButtonClick() {
    window.ProductAddons.addItem(this.currentVariantId);
    this.closeButton.click();
  }

  updateButtonState(checked) {
    if (checked) {
      this.addButton.disabled = true;
      this.addButtonContent.textContent = 'Added to order';
    } else {
      this.addButton.disabled = false;
      this.addButtonContent.textContent = 'Add to order';
    }
  }

  initSwipers() {
    const productGallery = this.closest('.product-addon-modal')
      .querySelector('.product-gallery');
    if (!productGallery) {
      return;
    }

    const thumbSwiperEl = productGallery.querySelector('.product-gallery__thumb-slider');
    const mainSwiperEl = productGallery.querySelector('.product-gallery__main-slider');

    if (thumbSwiperEl && mainSwiperEl) {
      this.thumbSwiper = new Swiper(thumbSwiperEl);
      this.mainSwiper = new Swiper(mainSwiperEl);
    }
  }
}

if (!customElements.get('product-addon-modal')) {
  customElements.define('product-addon-modal', ProductAddonModal);
}

document.addEventListener('variant:change', event => {
  window.ProductAddons.clear();
});

/************************************** add to cart button handler *******************************************/

document.addEventListener('DOMContentLoaded', () => {
  let addingAddons = false;

  window.upcartSubscribeCartLoaded(() => {
    window.upcartSubscribeAddedToCart(onAddToCart);
  });

  async function onAddToCart() {
    if (addingAddons) {
      return;
    }

    const addonIds = [
      ...new Set(
        window.ProductAddons
          .getItems()
          .map(id => String(id))
      )
    ];

    if (!addonIds.length) {
      return;
    }

    addingAddons = true;

    window.upcartShouldSkipAddToCart = () => true;

    try {
      const response = await fetch(
        window.Shopify.routes.root + 'cart/add.js',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: addonIds.map(id => ({
              id: Number(id),
              quantity: 1
            }))
          })
        }
      );

      if (!response.ok) {
        throw new Error(`Cart request failed: ${response.status}`);
      }
    } catch (error) {
      console.error('Error adding addons:', error);
    } finally {
      addingAddons = false;
      window.upcartShouldSkipAddToCart = () => false;
      window.upcartRefreshCart();
    }
  }
});

/************************************** variant picker *******************************************/

class VariantPicker extends HTMLElement {
  buttons;

  connectedCallback() {
    this.variantElements = document.querySelectorAll('[data-variant-id]');
    const select = this.querySelector('select');
    select.addEventListener('change', this.onButtonClick.bind(this));
  }

  onButtonClick(event) {
    const variantId = event.target.value;
    const variantElements = document.querySelectorAll('[data-variant-id]');
    variantElements.forEach(el => {
      el.toggleAttribute('hidden', el.dataset.variantId !== variantId);
    });

    this.updateUrlVariant(variantId);
    this.updateForm(variantId);

    const evt = new CustomEvent('variant:change', {
      detail: { variantId: variantId }
    });

    document.dispatchEvent(evt);
    this.resetAddonCheckboxes();
  }

  updateUrlVariant(variantId) {
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variantId);
    window.history.replaceState(null, '', url.toString());
  }

  resetAddonCheckboxes() {
    const checkboxes = document.querySelectorAll('.product-addon__checkbox');
    checkboxes.forEach(cb => {
      cb.checked = false;
    });
  }

  updateForm(variantId) {
    const input = document.querySelector('.product-form input.product-variant-id');
    input.value = variantId;
  }
}

if (!customElements.get('variant-picker')) {
  customElements.define('variant-picker', VariantPicker);
}